export default __webpack_public_path__ + "static/media/043-cul de sac.1eda70a7.png";